<template>
  <div class="wages wrapper shadow level-setting">
    <div class="operation">
      <div class="left">
        <div class="main-title">饭补级别设置</div>
      </div>
    </div>
    <div class="level-pane">
      <ul>
        <li v-for="(item, index) in levelList" :key="index">
            <div class="name">
                <span>
              <el-input
                  v-model="item.name"
                  placeholder="名称"
                  size="large"
              >
            </el-input>
              </span>
            </div>
          <div class="base-pay">
            <span>饭补金额：</span
            ><el-input
              v-model="item.amount"
              placeholder="饭补金额"
              size="large"
              type="number"
            >
              <template #prepend>￥</template>
            </el-input>
            <el-button
              class="del-btn"
              type="danger"
              :icon="Delete"
              @click="delClick(index)"
            ></el-button>
          </div>
        </li>
      </ul>
      <div class="operate-btn">
        <el-button
          type="warning"
          @click="addClick"
          class="main-btn main-btn-warning add-btn"
          >添加级别</el-button
        >
        <el-button
          type="primary"
          @click="saveClick"
          class="main-btn main-btn-primary save-btn"
          >保存设置</el-button
        >
      </div>
    </div>
  </div>
</template>

<script setup>
import {onMounted, ref} from "vue";
import { Delete } from "@element-plus/icons-vue";
import { ElMessage, ElMessageBox } from "element-plus";
import {fetchList, batchSave, batchUpdate } from "@/api/mealLevel";

onMounted(() => {
    getList();
});

const levelList = ref([]);

const getList = () => {
    fetchList().then((res) => {
        levelList.value = res.data.list
    });
}

// 添加一行
const addClick = () => {
  levelList.value.push({
      id: '',
      name: '',
      amount: '',
  });
};
// 删除一行
const delClick = (index) => {
  levelList.value.splice(index, 1);
};
// 保存设置
const saveClick = () => {
    let list = levelList.value
    let check = true
    list.forEach(e => {
        if (!e.name) {
            check = false
        }
        if(!e.amount) {
            e.amount = 0
        }
    })
    if (!check) {
        ElMessage({
            type: "error",
            message: "请将数据填写完整！",
        });
        return
    }
  ElMessageBox.confirm("确定要保存设置吗?", "提示", {
    confirmButtonText: "确定",
    cancelButtonText: "取消",
    type: "warning",
  })
    .then(() => {
        batchSave({ list: levelList.value }).then(() => {
            getList()
            ElMessage({
                type: "success",
                message: "保存成功！",
            });
        })
    })
    .catch(() => {});
};
</script>

<style lang="scss" scoped>
.level-setting {
  .level-pane {
    ul {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      li {
        width: 48%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        background: #e0f2ff;
        padding: 5px 10px;
        margin: 0 0 10px 0;
        .name {
          span {
            font-size: 18px;
            font-weight: bold;
            color: $main-color;
          }
        }
        .base-pay {
          display: flex;
          align-items: center;
          span {
            white-space: nowrap;
          }
          ::v-deep .el-input {
            .el-input__inner {
              font-size: 18px;
              font-weight: bold;
              color: $main-color;
              &::placeholder {
                font-size: 14px;
                font-weight: normal;
              }
            }
          }
          .del-btn {
            margin: 0 0 0 10px;
            padding: 8px 10px;
            font-size: 18px;
          }
        }
      }
    }
  }
  .operate-btn {
    margin: 10vh auto 0;
    width: fit-content;
    .save-btn {
      width: 240px;
    }
  }
}
@media (max-width:1200px) {
		.level-pane{
			li{
				width: 100%!important;
			}
		}
	}
</style>
